import React, { FC } from 'react';

import {
  Tooltip,
  TooltipReference,
  TooltipArrow,
  useTooltipState,
} from 'reakit/Tooltip';

import cn from 'classnames';

import disabledIcon from '@assets/disabledIcon.svg';
import enabledIcon from '@assets/enabledIcon.svg';

import st from './Rating.module.css';

type RatingProps = {
  handleEnableRating: (enabled: boolean) => void;
  enabled: boolean;
  phone: boolean;
};

const Rating: FC<RatingProps> = ({ handleEnableRating, enabled, phone }) => {
  const mainClassName = cn(st.main, {
    [st.mainMobile]: phone,
  });

  const tooltip = useTooltipState();

  return (
    <div className={mainClassName}>
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <TooltipReference {...tooltip}>
        <button
          type="button"
          data-testid="ratingTooltipButton"
          className={st.tooltipButton}
          onClick={() => handleEnableRating(!enabled)}
        >
          <img
            className={st.ratingIcon}
            src={enabled ? enabledIcon : disabledIcon}
            alt="Rating"
          />
          <span className={st.description}>{phone ? '' : 'Оценка'}</span>
        </button>
      </TooltipReference>
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <Tooltip {...tooltip} className={st.tooltipContent}>
        {/* eslint-disable-next-line react/jsx-props-no-spreading */}
        <TooltipArrow {...tooltip} />
        Оценки центров за всё время
      </Tooltip>
    </div>
  );
};

export default Rating;
